import React from 'react';
import PropTypes from 'prop-types';

export const Upload = ({ width, height, ...props }) => (
  <svg
    data-icon='upload'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11 16V7.85l-2.6 2.6L7 9l5-5 5 5-1.4 1.45-2.6-2.6V16h-2Zm-5 4c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 18v-3h2v3h12v-3h2v3c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 18 20H6Z'
    />
  </svg>
);

Upload.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Upload.defaultProps = {
  width: 24,
  height: 24,
};
